import { ActionReducerMap, createSelector } from '@ngrx/store';
import * as reducers from './reducers';

export namespace OnboardingProductsStore {

  export interface AppState {
    stepsNoClient: reducers.StepNotClientState;
    stepsClient: reducers.StepClientState ;
    clientAdmission: reducers.ClientAdmissionState;
    emailValidateState: reducers.EmailValidateState;
    isCTSEmployee: reducers.IsCTSEmployeeState;
    reqManagerGet: reducers.ReqManagerGetState;
    reqManagerCreate: reducers.ReqManagerCreateState;
    addressManagerCreate: reducers.AddressManagerCreateState;
    laborManagerCreate: reducers.LaborManagerCreateState;
    nationalityManagerCreate: reducers.NationalityManagerCreateState;
    currencyType: reducers.CurrencyTypeState;
    financialDataManagerCreate: reducers.FinancialDataManagerCreateState;
    termsAndConditionsManagerCreate: reducers.TermsAndConditionsManagerCreateState;
    passiveDocumentCreation: reducers.PassiveDocumentCreationState;
    customerChallengeGenerate: reducers.CustomerChallengeGenerateState;
    checkToken: reducers.CheckTokenState;
    passwordCreate: reducers.PasswordCreateState;
    cigo: reducers.CigoState;
    createUserAccount: reducers.CreateUserAccountState;
    createProduct: reducers.CreateProductState;
    clientExternalChallenge: reducers.ClientExternalChallengeState;
    clientExternalIdentity: reducers.ClientExternalIdentityState;
    pio: reducers.PioState;
    pep: reducers.PepDataState;
    clientStatePasswordGet: reducers.ClientStatePasswordGetState;
    documentSignature: reducers.DocumentSignatureState;
    tri: reducers.TriState;
    validateSession: reducers.ValidateSessionState;
    tre: reducers.TreState;
    ui: reducers.UiState;
  }

  const featureSelector = (state: AppState) => state;

  export const selectors = {
    stepsNoClient: createSelector(featureSelector, (state: AppState) => state.stepsNoClient),
    stepsClient: createSelector(featureSelector, (state: AppState) => state.stepsClient),
    clientAdmission: createSelector(featureSelector, (state: AppState) => state.clientAdmission),
    emailValidateState: createSelector(featureSelector, (state: AppState) => state.emailValidateState),
    isCTSEmployee: createSelector(featureSelector, (state: AppState) => state.isCTSEmployee),
    reqManagerGet: createSelector(featureSelector, (state: AppState) => state.reqManagerGet),
    reqManagerCreate: createSelector(featureSelector, (state: AppState) => state.reqManagerCreate),
    addressManagerCreate: createSelector(featureSelector, (state: AppState) => state.addressManagerCreate),
    laborManagerCreate: createSelector(featureSelector, (state: AppState) => state.laborManagerCreate),
    nationalityManagerCreate: createSelector(featureSelector, (state: AppState) => state.nationalityManagerCreate),
    currencyType: createSelector(featureSelector, (state: AppState) => state.currencyType),
    financialDataManagerCreate: createSelector(featureSelector, (state: AppState) => state.financialDataManagerCreate),
    termsAndConditionsManagerCreate: createSelector(featureSelector, (state: AppState) => state.termsAndConditionsManagerCreate),
    passiveDocumentCreation: createSelector(featureSelector, (state: AppState) => state.passiveDocumentCreation),
    customerChallengeGenerate: createSelector(featureSelector, (state: AppState) => state.customerChallengeGenerate),
    checkToken: createSelector(featureSelector, (state: AppState) => state.checkToken),
    passwordCreate: createSelector(featureSelector, (state: AppState) => state.passwordCreate),
    cigo: createSelector(featureSelector, (state: AppState) => state.cigo),
    createUserAccount: createSelector(featureSelector, (state: AppState) => state.createUserAccount),
    createProduct: createSelector(featureSelector, (state: AppState) => state.createProduct),
    clientExternalChallenge: createSelector(featureSelector, (state: AppState) => state.clientExternalChallenge),
    clientExternalIdentity: createSelector(featureSelector, (state: AppState) => state.clientExternalIdentity),
    pio: createSelector(featureSelector, (state: AppState) => state.pio),
    pep: createSelector(featureSelector, (state: AppState) => state.pep),
    clientStatePasswordGet: createSelector(featureSelector, (state: AppState) => state.clientStatePasswordGet),
    documentSignature: createSelector(featureSelector, (state: AppState) => state.documentSignature),
    tri: createSelector(featureSelector, (state: AppState) => state.tri),
    validateSession: createSelector(featureSelector, (state: AppState) => state.validateSession),
    tre: createSelector(featureSelector, (state: AppState) => state.tre),
    ui: createSelector(featureSelector, (state: AppState) => state.ui)
  };

  export const appReducers: ActionReducerMap<AppState> = {
    stepsNoClient: reducers.stepsNotClientReducer,
    stepsClient: reducers.stepsClientReducer,
    clientAdmission: reducers.clientAdmissionReducer,
    emailValidateState: reducers.emailValidateReducer,
    isCTSEmployee: reducers.isCTSEmployeeReducer,
    reqManagerGet: reducers.reqManagerGetReducer,
    reqManagerCreate: reducers.reqManagerCreateReducer,
    addressManagerCreate: reducers.addressManagerCreateReducer,
    laborManagerCreate: reducers.laborManagerCreateReducer,
    nationalityManagerCreate: reducers.nationalityManagerCreateReducer,
    currencyType: reducers.currencyTypeReducer,
    financialDataManagerCreate: reducers.financialDataManagerCreateReducer,
    termsAndConditionsManagerCreate: reducers.termsAndConditionsManagerCreateReducer,
    passiveDocumentCreation: reducers.passiveDocumentCreationReducer,
    customerChallengeGenerate: reducers.customerChallengeGenerateReducer,
    checkToken: reducers.checkTokenReducer,
    passwordCreate: reducers.passwordCreateReducer,
    cigo: reducers.cigoReducer,
    createUserAccount: reducers.createUserAccountReducer,
    createProduct: reducers.createProductReducer,
    clientExternalChallenge: reducers.clientExternalChallengeReducer,
    clientExternalIdentity: reducers.clientExternalIdentityReducer,
    pio: reducers.pioReducer,
    pep: reducers.pepReducer,
    clientStatePasswordGet: reducers.clientStatePasswordGetReducer,
    documentSignature: reducers.documentSignatureReducer,
    tri: reducers.triReducer,
    validateSession: reducers.validateSessionReducer,
    tre: reducers.TreReducer,
    ui: reducers.uiReducer
  };
}
